<div class="d-flex flex-column instrument-item px-p-10 px-mx-10" [formGroup]="instrumentItemFormGroup">
    <div class="d-flex flex-row justify-content-between">
        <select [(ngModel)]="selectedInstrument" class="form-control mr-sm-2 form-control-sm px-w-160"
                [disabled]="mode === modelPopupMode.view"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onIntrumentChange($event)">
            <option [ngValue]="null">Select an instrument</option>
            <option *ngFor="let item of instrumentConfigs" [ngValue]="item" [disabled]="isDisabled(item?.instrument)">{{item?.instrument}}</option>
        </select>
        <span class="logo-btn-small close" (click)="onRemoveInstrument()" *ngIf="index > 0 && mode !==  modelPopupMode.view"></span>
    </div>

    <div class="" *ngIf="selectedInstrument !== null">
        <div class="d-flex flex-row instrument-input-table custom-table px-mt-10" *ngIf="selectedInstrument !== null">
            <div *ngIf="selectedInstrument.numberOfLegs > 1" class="d-flex flex-column">
                <div> Leg</div>
                <div> 1</div>
                <div> 2</div>
            </div>
            <ng-container *ngFor="let config of columnConfig" [ngSwitch]="config.controlType">
                <ng-container *ngSwitchCase="'standard'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset">
                    </app-instrument-column>
                </ng-container>
                <ng-container *ngSwitchCase="'accounting'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable &&  (!config.onTradeExecuted ||
                                                    mode === modelPopupMode?.tradeExecuted || instrument?.tradeExecuted) &&!formReset"
                                            [class.trade-executed-column]="config.onTradeExecuted">
                    </app-instrument-column>
                </ng-container>
                <ng-container *ngSwitchCase="'legType'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset"
                                            (selectOptionChange)="onLegTypeChange($event)">
                    </app-instrument-column>
                </ng-container>
                <!-- == Previously, coupon(%) was disabled when legType=Float ==
                <ng-container *ngSwitchCase="'fixedRateCoupon'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset"
                                            [disableControl]="selectedInstrument.numberOfLegs>1 ? disableCoupon:null">
                    </app-instrument-column>
                </ng-container>
                -->
                <ng-container *ngSwitchCase="'spread'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset"
                                            [disableControl]="selectedInstrument.numberOfLegs>1 ? disableSpread: null">
                    </app-instrument-column>
                </ng-container>
                <ng-container *ngSwitchCase="'refForward'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="config.controlName"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset"
                                            [disableControl]="selectedInstrument.numberOfLegs>1 ? disableRefForward: null">
                    </app-instrument-column>
                </ng-container>
                <ng-container *ngSwitchCase="'counterParty'">
                    <app-instrument-column  [parentFormGroup]="instrumentItemFormGroup"
                                            [numberOfLegs]="selectedInstrument.numberOfLegs"
                                            [mode]="mode"
                                            [dynamicFormControlName]="counterParty"
                                            [columnConfig]="config"
                                            *ngIf="config.enable && !formReset">
                    </app-instrument-column>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <button title="Software Error for column ' + config.controlType">{{config.controlType}}</button>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
